// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2A1NW","itemTitle":"ClientEmergencyInfo_itemTitle__3nUhs","itemText":"ClientEmergencyInfo_itemText__3Rd27"};